<template>
  <component v-if="component"
    :is="component"
    :locale="locale" />
</template>

<script>
export default {
  name: 'SeparatePament',
  props: [
    'locale'
  ],
  computed: {
  },
  mounted () {
    const pg = this.$route.params.pg
    const pgid = this.$route.params.pgid
    const paymentComponent = pg ? pg.replace(/\b\w/g, l => l.toUpperCase()) : null
    this.$store.dispatch('payment/getPgInfo', pgid).then((res) => {
      if (res) {
        this.$store.commit('payment/setPaymentInfo', res)
        this.component = () => import(`@/components/Payment/${paymentComponent}.vue`)
      }
    })
  },
  data () {
    return {
      component: null
    }
  },
  methods: {
  }
}
</script>
